export default __webpack_public_path__ + "static/testimonials-cards-capterra-logo-d5bba41c5c6439047a84ab42e11286aa.svg";